<ng-container *ngIf="isBlocked">
  <!-- Backdrop (blurs everything behind) -->
  <div class="overlay-backdrop" @overlayFade></div>

  <!-- Modal card -->
  <div class="overlay-card" @cardPop>
    <div class="overlay-icon" [class.icon--suspended]="isSuspended">
      <svg *ngIf="!isSuspended" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 3C9.373 3 4 8.373 4 15c0 6.628 5.373 12 12 12s12-5.372 12-12C28 8.373 22.627 3 16 3zm0 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-6h-2V9h2v6z" fill="currentColor"/>
      </svg>
      <svg *ngIf="isSuspended" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M16 3C9.373 3 4 8.373 4 15c0 6.628 5.373 12 12 12s12-5.372 12-12C28 8.373 22.627 3 16 3zm-1.5 6h3v8h-3V9zm0 10h3v3h-3v-3z" fill="currentColor"/>
      </svg>
    </div>

    <div class="overlay-badge" [class.badge--suspended]="isSuspended">
      {{ badgeText }}
    </div>

    <h2 class="overlay-title">{{ title }}</h2>
    <p class="overlay-subtitle">{{ subtitle }}</p>

    <div class="overlay-actions">
      <button class="btn-cta" (click)="openCta()">
        {{ ctaLabel }}
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button class="btn-logout" (click)="logout()">Sign out</button>
    </div>

    <p class="overlay-note" *ngIf="!isSuspended">
      Already upgraded? <a href="javascript:void(0)" (click)="logout()">Sign in again</a> to refresh your access.
    </p>
  </div>
</ng-container>
